import { getUnique } from "@/utils/number/unique";

export function FieldVariant(variant = "") {
    if (typeof variant === "string")
        return {
            unique: getUnique(),
            id: null,
            text: variant,
        };
    return {
        unique: getUnique(),
        id: `${variant.id}`,
        text: variant.name,
    };
}

export function formatFieldVariant(variant) {
    return {
        id: variant.id,
        name: variant.text,
    };
}
